import { Component } from '@angular/core';
import { ChatBottomComponent } from './chat-bottom/chat-bottom.component';
import { ChatMessagesComponent } from './chat-messages/chat-messages.component';
import { ChatTopBarComponent } from './chat-top-bar/chat-top-bar.component';
import { ChatTriviaComponent } from './chat-trivia/chat-trivia.component';
import { ChatTriviaRainComponent } from './chat-trivia-rain/chat-trivia-rain.component';
import { ChatService } from './chat.service';
import { SessionService } from '@shared/session.service';
import { SignInBlockComponent } from '@shared/sign-in-block/sign-in-block.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  imports: [ChatTopBarComponent, ChatMessagesComponent, ChatTriviaRainComponent, ChatTriviaComponent, SignInBlockComponent, ChatBottomComponent],
})
export class ChatComponent {
  constructor(public chatService: ChatService, public session: SessionService, public uiService: UIService) {}
}
